export default {"src":"/_next/static/media/type_enseignement.1934ef9b.svg","height":803,"width":983};